module.exports = __webpack_public_path__ + "media/images/join-1 2-cd597872c6ef2b4fecbf7a25e606c3f1.jpg";